import { BareActionContext } from 'vuex-typex'
import { AuthState } from '@/store/auth/state'
import { RootState } from '@/store/'
import authUtils from '@/store/auth/actions/auth-utils'
import mainStore from '@/store/main/main-store';

export default async function saveState(context: BareActionContext<AuthState, RootState>) {
  authUtils.authService.saveState({page: mainStore.page, id: mainStore.id, uid: mainStore.uid})
}
